// Wrapper de fetch do SPA: cookies same-origin (sessão Devise) + CSRF token.
// O token inicial vem do meta tag (Rails csrf_meta_tags); após o login a sessão
// é resetada, então o store atualiza o token com o retornado pelo sign-in.
let csrfToken =
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''

export function setCsrfToken(token) {
  if (token) csrfToken = token
}

export async function refreshCsrfToken() {
  const response = await fetch('/api/csrf', {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin',
    cache: 'no-store',
  })

  if (!response.ok) throw new Error('Falha ao iniciar sessão segura.')

  const data = await response.json()
  setCsrfToken(data.csrf_token)
  return data.csrf_token
}

export async function api(path, { method = 'GET', body } = {}) {
  const headers = { Accept: 'application/json' }
  // FormData (upload multipart) define o próprio Content-Type com boundary —
  // setar na mão quebraria o parse do Rails.
  const isFormData = body instanceof FormData
  if (body !== undefined && !isFormData) headers['Content-Type'] = 'application/json'
  if (method !== 'GET') headers['X-CSRF-Token'] = csrfToken

  return fetch(path, {
    method,
    headers,
    credentials: 'same-origin',
    body: isFormData ? body : body !== undefined ? JSON.stringify(body) : undefined,
  })
}
